import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
// import { webapi } from '../../shared/my-constants';
import {webapi, fingerprinturl,medify} from '../../shared/my-constants';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs/Observable';





 @Injectable()
export class PatientRegistrationService {
    private headers = new Headers({'Content-Type': 'application/json'});
    private headers1 = new Headers({
        'Content-Type': 'application/json',
        'access-control-allow-credentials': 'true',
        'access-control-allow-headers': 'Content-Type, Accept, X-Requested-With,Pharmacy-Key, remember-me',
        'access-control-allow-methods': 'POST, GET,',
        'access-control-allow-origin': 'chrome-extension:// fhbjgbiflinjbdggehcddcbncdddomop',
        'access-control-max-age': '3600',
        'content-type': 'text/plain;charset=UTF-8',
        'Pharmacy-Key': '3D1japAizUClyEAUZfglpBIEvasPSSdy'});
    private headersfile = new Headers({
        'access-control-allow-credentials': 'true',
        'access-control-allow-headers': 'Content-Type, Accept, X-Requested-With, remember-me',
        'access-control-allow-methods': 'POST, GET, OPTIONS, DELETE, PUT',
        'access-control-allow-origin': 'chrome-extension:// fhbjgbiflinjbdggehcddcbncdddomop',
        'access-control-max-age': '3600',
        'content-length': '38',
        'content-type': 'text/plain;charset=UTF-8'
    });
    private ListRecord = webapi + 'mst_staff/list/?';
    private AddRecorduser = webapi + 'mst_patient/create';
    private AddRecordvisit = webapi + 'trn_visit/create';
    private EditRecord = webapi + 'mst_staff/update';
    private GetRecord = webapi + 'mst_patient/byid/';
    private DeleteRecord = webapi + 'mst_staff/delete/';
    private fileupload = webapi + 'api/upload/';
    private GetBasepath = webapi + 'mst_patient/getbasepath/';
    private Addrevisit = webapi + 'mst_patient/revisit';
    private Addemrrevisit = webapi + 'mst_patient/emrrevisit';
    private ancoreg = 'http:// 192.168.1.106/oncowebservice/Service1.asmx/InsertPatientRecord?';
    private appoinmentconformsms = webapi + 'smssend/AppoinmentConform/';
    private registrationsuccesssms = webapi + 'smssend/registrationsuccesful/';
    private admissionsuccesssms = webapi + 'smssend/admissionsuccesful/';
    private dischargesuccesssms = webapi + 'smssend/dischargesuccesful';
    private appoinmentcancel = webapi + 'smssend/AppoinmentConform/';
    private searchByAadharNo = webapi + 'aadhar/findByAadharNo/';
     private ListRecordByColumnName = webapi + 'mst_patient/search/?';
    private ImpotExcel = webapi + 'api/impotExcel/';
    private GetRowCount = webapi + 'api/getRowCount/';
    private SaveMedi = 'https://stageservices.medify.net/webservices/api/store/patient';
     // private apiUrl = environment.apiUrl;

    constructor(
         private http: Http,
    ) {
    }

    secondvisit(user: any) {
        return this.http.post(this.Addrevisit, JSON.stringify(user), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    emrSecondvisit(user: any) {
        return this.http.post(this.Addemrrevisit, JSON.stringify(user), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    searchByAadharCardNo(aadharNo: any) {
        return this.http.get(this.ListRecordByColumnName + aadharNo)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    addfile(form) {
        console.log(form);
        return this.http.post(this.fileupload, form)
            .toPromise()
            .then(response => response as any)
            .catch(this.handleError);
    }

    saveinuser(user: any) {
        return this.http.post(this.AddRecorduser, JSON.stringify(user), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    saveinvisit(visit: any) {
        return this.http.post(this.AddRecordvisit, JSON.stringify(visit), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRecordService(id: any) {
        return this.http.get(this.GetRecord + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    gatbasepath() {
        return this.http.get(this.GetBasepath)
            .toPromise()
            .then(response => response as any)
            .catch(this.handleError);
    }

    oncoreg(title: any, mrno: any, patientname: any) {
        console.log(this.ancoreg + 'strPId=' + mrno + '&strTitle=' + title + '&strPtName=' + patientname + '&strDOB=&strGender=&strAddress=&strLandmark=&strCity=&strState=&strCountry=&strPincode=&strMobile1=&strLandline=&strRegistrationDate=&strHospitalName=&floatHeight=&floatWeight=&strMobile2=&strTaluka=Delhi&strDistrict=&strMob1Name=&strMob2Name=&strOccupation=&strMaritalStatus=&strPaymentBy=&strRemarks=%&strProviderDetails=&strWhetherToContactPatient=&strUserId=&strTodayDate=&strUpdateBy=&strUpdateDate=&strFirstName=&strMiddleName=&strLastName=&strAgeYears=&strAgeMonths=&strAgeDays=&strReferredBy=');
        //   return this.http.get(this.ancoreg + 'strPId='+mrno+'&strTitle='+title+'&strPtName='+patientname+'&strDOB=&strGender=&strAddress=&strLandmark=&strCity=&strState=&strCountry=&strPincode=&strMobile1=&strLandline=&strRegistrationDate=&strHospitalName=&floatHeight=&floatWeight=&strMobile2=&strTaluka=Delhi&strDistrict=&strMob1Name=&strMob2Name=&strOccupation=&strMaritalStatus=&strPaymentBy=&strRemarks=&strProviderDetails=&strWhetherToContactPatient=&strUserId=&strTodayDate=&strUpdateBy=&strUpdateDate=&strFirstName=&strMiddleName=&strLastName=&strAgeYears=&strAgeMonths=&strAgeDays=&strReferredBy=')
        return this.http.get(this.ancoreg + 'strPId=' + mrno + '&strTitle=' + title + '&strPtName=' + patientname)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    //  smsemail send
    sendmessageappoinmentconform(appoinmentId: any) {
        return this.http.get(this.appoinmentconformsms + appoinmentId)
            .toPromise()
            .then(response => response as any)
            .catch(this.handleError);
    }
    sendmessageRegistrationSuccess(patientId: any) {
        return this.http.get(this.registrationsuccesssms + patientId)
            .toPromise()
            .then(response => response as any)
            .catch(this.handleError);
    }
    sendmessageAdmissionSuccess(model: any) {
        return this.http.post(this.admissionsuccesssms, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response as any)
            .catch(this.handleError);
    }
    sendmessageDischargeSuccess(model: any) {
        return this.http.post(this.dischargesuccesssms, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response as any)
            .catch(this.handleError);
    }


    //  smsemail send
    captureImage() {
        return this.http.get(fingerprinturl)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    impotExcel(form, unitId: any, count: any, isRadiology: any, isOPD: any) {
        console.log(form);
        return this.http.post(this.ImpotExcel + unitId  +'/' + count + '/' + isRadiology+ '/' + isOPD, form)
            .toPromise()
            .then(response => response as any)
            .catch(this.handleError);
    }
    getRowCount(form) {
        console.log(form);
        return this.http.post(this.GetRowCount, form)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    saveinuser1(user: any)  {
        return this.http.post(this.SaveMedi, JSON.stringify(user),{headers: this.headers1})
            .toPromise()
            .then(response => response.toString())
            .catch(this.handleError);
    }


    //
    //      saveinuser1(data: any): Observable<any> {
    //
    //
    //      return this.http.post(this.apiUrl, data,  {headers: this.headers1} );
    //  }



     private handleError(error: Response | any) {
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/opd/patient-registration/patient-registration.service.ts